import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { EntityFieldValue, EntitiesProps } from 'services/entities/types';

// Global Selectors
import { makeSelectEntityPathNames } from 'services/entities/selectors';

type OwnProps = EntitiesProps;

interface ConnectedProps {
    pathNames?: EntityFieldValue;
}

type Props = OwnProps & ConnectedProps;

export class EntityPathNamesValueComponent extends React.PureComponent<Props> {
    render(): string | null {
        const { pathNames } = this.props;

        if (!pathNames) {
            return null;
        }

        return pathNames;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    pathNames: makeSelectEntityPathNames()
});

export default connect(mapStateToProps)(EntityPathNamesValueComponent);
